import { ReactNode } from 'react';
import { MessageDescriptor } from 'react-intl';
import styled from 'styled-components';

import Button from 'atoms/buttons/Button';
import { Horizontal, Vertical } from 'atoms/layout/flex';
import { TimeUntilNext } from 'atoms/ticker/TimeUntilNext';
import { HeadlineS, Text14 } from 'atoms/typography';

const Banner = styled.div`
  display: flex;
  position: relative;

  border-radius: var(--triple-unit);
  color: var(--c-static-neutral-100);

  padding-left: calc(3 * var(--unit));
  padding-right: calc(1 * var(--unit));

  cursor: pointer;
  &:hover {
    button {
      background: var(--c-brand-300) !important;
    }
  }
`;

const Content = styled(Vertical).attrs({ gap: 2 })`
  justify-content: space-between;
  flex: 1;
  margin: var(--double-unit) 0;
`;

export const Icon = styled.img`
  position: absolute;
  right: calc(1 * var(--unit));
  margin: var(--half-unit);
  align-self: center;
  justify-content: center;
  height: 90px;
`;

const Text = styled(Vertical).attrs({ gap: 1 })`
  justify-items: flex-start;
  text-align: left;
  padding-right: calc(10 * var(--unit));
`;

const Subtitle = styled(Text14)`
  font: var(--t-14);
  line-height: 1;
`;

const Cta = styled(Horizontal)`
  align-self: flex-start;

  & button {
    border: 1px solid var(--c-brand-300);
  }
`;

const TimeUntilNextStyled = styled(TimeUntilNext)`
  font: var(--t-12);
`;
type Props = {
  title: ReactNode;
  subtitle: ReactNode;
  cta: ReactNode;
  timeLeftMessage: MessageDescriptor;
  ctaAvailable: boolean;
  nextAvailableDate: Date;
  onClick: () => void;
  icon: ReactNode;
  className?: string;
  showTimeUntilNext?: boolean;
};

export const GenericBanner = ({
  title,
  subtitle,
  cta,
  timeLeftMessage,
  ctaAvailable,
  nextAvailableDate,
  onClick,
  icon,
  className,
  showTimeUntilNext = false,
}: Props) => {
  return (
    <Banner onClick={onClick} className={className}>
      <Content>
        <Text>
          <HeadlineS>{title}</HeadlineS>
          <Subtitle>{subtitle}</Subtitle>
        </Text>
        <Cta>
          {ctaAvailable && (
            <Button color="secondary" size="small">
              {cta}
            </Button>
          )}
          {(!ctaAvailable || showTimeUntilNext) && (
            <TimeUntilNextStyled
              timeLeftMessage={timeLeftMessage}
              next={nextAvailableDate}
            />
          )}
        </Cta>
      </Content>
      {icon}
    </Banner>
  );
};
